export default __webpack_public_path__ + "static/media/spinninbeans-site.b139f4da.png";